"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formDataToObject = void 0;
// Function to convert form data to object
const formDataToObject = (formData) => {
    const entries = formData.entries();
    const object = {};
    for (const [key, value] of entries) {
        object[key] = value;
    }
    return object;
};
exports.formDataToObject = formDataToObject;
